import { render, staticRenderFns } from "./Isactived.vue?vue&type=template&id=650656da&scoped=true&"
import script from "./Isactived.vue?vue&type=script&lang=ts&"
export * from "./Isactived.vue?vue&type=script&lang=ts&"
import style0 from "./Isactived.vue?vue&type=style&index=0&id=650656da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650656da",
  null
  
)

export default component.exports